module.exports = __webpack_public_path__ + "static/media/shards-dashboards-logo.3a4799be.svg";